/*
  LIORIVE — "Ajouter" on cart-drawer recommendations (single-variant products only).
  Uses Dawn's own cart API flow: POST routes.cart_add_url with the drawer sections, then
  cart-drawer.renderContents(). Event delegation, so it survives drawer re-renders. No dependencies.
*/
document.addEventListener('click', async (event) => {
  const button = event.target.closest('[data-liorive-add]');
  if (!button || button.getAttribute('aria-disabled') === 'true') return;
  const drawer = document.querySelector('cart-drawer');
  if (!drawer) return;

  button.setAttribute('aria-disabled', 'true');
  button.classList.add('loading');
  try {
    const body = new FormData();
    body.append('id', button.getAttribute('data-liorive-add'));
    body.append('quantity', '1');
    body.append('sections', drawer.getSectionsToRender().map((section) => section.id));
    body.append('sections_url', window.location.pathname);
    const response = await fetch(window.routes.cart_add_url, {
      method: 'POST',
      headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' },
      body,
    });
    const state = await response.json();
    if (state.status) throw new Error(state.description || state.message || 'add failed');
    drawer.renderContents(state); // re-renders the drawer, including this button
  } catch (e) {
    button.removeAttribute('aria-disabled');
    button.classList.remove('loading');
    button.textContent = 'Indisponible';
  }
});
